"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Control["default"];
  }
});
var _Control = _interopRequireDefault(require("./Control"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }